import { customElement } from '@aurelia/runtime-html';
import * as __au2ViewDef from './relationclass-buttongroup.html';
import { GlobalClassObject } from './../../resources/global_class_object';
import { Relationclass, RelationclassInstance } from "../../../../mmar-global-data-structure";
import { GlobalRelationclassObject } from 'resources/global_relationclass_object';
import { GlobalStateObject } from 'resources/global_state_object';
import { GlobalDefinition } from 'resources/global_definitions';
import { bindable, EventAggregator } from 'aurelia';

@customElement(__au2ViewDef)
export class RelationclassButtongroup {

    @bindable openTab = null;

    constructor(
        private globalClassObject: GlobalClassObject,
        private globalRelationclassObject: GlobalRelationclassObject,
        private globalStateObject: GlobalStateObject,
        //do not delete -> needed for the html 
        private globalObjectInstance: GlobalDefinition,
        private eventAggregator: EventAggregator
    ) {
        this.eventAggregator.subscribe('tabChanged', async () => {
            await this.setIcons();
        });
    }

    async attached() {
        await this.setIcons();
    }

    onButtonClicked(uuid: string) {
        this.globalRelationclassObject.setSelectedRelationClassByUUID(uuid);

        this.globalStateObject.setState(3);
    }

    async getImage(metaclass: Relationclass) {
        const geometry = metaclass.geometry;
        const icon = await this.globalClassObject.getIcon(geometry.toString());
        return icon;
    }

    async setIcons() {
        //call getImage on all Classes of globalObjectInstance.tabContext[globalObjectInstance.selectedTab].sceneType.classes
        const relationclasses = this.globalObjectInstance.tabContext[this.globalObjectInstance.selectedTab].sceneType.relationclasses;
        for (const metaclass of relationclasses) {
            metaclass["icon"] = undefined;
            const icon = await this.getImage(metaclass);
            metaclass["icon"] = icon;
        }
    }
}
    import { Metadata as $$M } from '@aurelia/metadata';
    import { ExpressionKind as $$EK } from '@aurelia/runtime';
    import { Controller as $$C, CustomElement as $$CE, IHydrationContext as $$IHC } from '@aurelia/runtime-html';

    // @ts-ignore
    const controllers = [];

    // @ts-ignore
    if (module.hot) {

    // @ts-ignore
    module.hot.accept();

    // @ts-ignore
    const hot = module.hot;

    let aurelia = hot.data?.aurelia;

    // @ts-ignore
    document.addEventListener('au-started', (event) => {aurelia= event.detail; });
    const currentClassType = RelationclassButtongroup;

    // @ts-ignore
    const proto = RelationclassButtongroup.prototype

    // @ts-ignore
    const ogCreated = proto ? proto.created : undefined;

    if (proto) {
      // @ts-ignore
      proto.created = function(controller) {
        // @ts-ignore
        ogCreated && ogCreated.call(this, controller);
        controllers.push(controller);
      }
    }

    // @ts-ignore
    hot.dispose(function (data) {
      // @ts-ignore
      data.controllers = controllers;
      data.aurelia = aurelia;
    });

    if (hot.data?.aurelia) {
      const newDefinition = $$CE.getDefinition(currentClassType);
      $$M.define(newDefinition.name, newDefinition, currentClassType);
      $$M.define(newDefinition.name, newDefinition, newDefinition);
      hot.data.aurelia.container.res[$$CE.keyFrom(newDefinition.name)] = newDefinition;

      const previousControllers = hot.data.controllers ?? [];
      if(previousControllers.length === 0) {
        // @ts-ignore
        hot.invalidate?.();
      }

      // @ts-ignore
      previousControllers.forEach(controller => {
        const values = { ...controller.viewModel };
        const hydrationContext = controller.container.get($$IHC)
        const hydrationInst = hydrationContext.instruction;

        const bindableNames = Object.keys(controller.definition.bindables);
        // @ts-ignore
        Object.keys(values).forEach(key => {
          if (bindableNames.includes(key)) {
            return;
          }
          // if there' some bindings that target the existing property
          // @ts-ignore
          const isTargettedByBinding = controller.bindings?.some(y =>
            y.ast?.$kind === $$EK.AccessScope
              && y.ast.name === key && y.targetProperty
          );
          if (!isTargettedByBinding) {
            delete values[key];
          }
        });
        const h = controller.host;
        delete controller._compiledDef;
        controller.viewModel = controller.container.invoke(currentClassType);
        controller.definition = newDefinition;
        Object.assign(controller.viewModel, values);
        if (controller._hydrateCustomElement) {
          controller._hydrateCustomElement(hydrationInst, hydrationContext);
        } else {
          controller.hE(hydrationInst, hydrationContext);
        }
        h.parentNode.replaceChild(controller.host, h);
        controller.hostController = null;
        controller.deactivate(controller, controller.parent ?? null, 0);
        controller.activate(controller, controller.parent ?? null, 0);
      });
    }
  }